<script>
  import Cells from './cells'

  export default {
    Cells,
  }
</script>



// WEBPACK FOOTER //
// index.vue?4012fcff